{
  "en": {
    "feature_groups": {
      "aftercare": "Aftercare",
      "announcements": "Announcements",
      "conversations": "Conversations",
      "customer_pwa": "Customer PWA",
      "decisions": "Decisions",
      "documents": "Documents",
      "email_forwarding": "Email forwarding",
      "faqs": "FAQs",
      "financials": "Financials",
      "inspirations": "Inspirations",
      "localization": "Localization",
      "partner_portal": "Partner portal",
      "projects": "Projects",
      "property_development": "Property development",
      "surveys": "Surveys",
      "tasks": "Tasks",
      "workflows": "Workflows and milestones"
    },
    "feature_matrix": {
      "aftercare": "Aftercare",
      "aftercare_customer_feedback": "Request customer approval",
      "ai_assistant": "AI assistant",
      "announcements": "Announcements",
      "conversation_agent": "AI agent in conversations",
      "conversation_mentions": "Notes and mentions",
      "decisions_core": "Decisions",
      "decisions_documents": "Decision documents",
      "decisions_financials": "Decision financials",
      "decisions_financials_extended": "Extended decision financials",
      "decisions_partners": "Decision partners",
      "decisions_proposals_multiple_approval": "Multiple proposals approval",
      "decisions_reminders": "Reminders",
      "decisions_tickets": "Linked conversations",
      "document_categories": "Custom categories",
      "documents": "Documents",
      "email_forwarding_client": "Forward to client and project address",
      "employee_custom_theme": "Custom theme",
      "employee_import_customers": "Import: customers",
      "employee_import_spaces": "Import: spaces",
      "employee_import_units": "Import: units",
      "faqs": "FAQs",
      "financials": "Financials",
      "information_full": "RED input fields",
      "inspirations": "Inspirations",
      "mobile_app_customer": "Mobile app in your branding",
      "multilingual": "Multilingual content",
      "multilingual_announcements": "Multilingual: news only",
      "project_partners": "Project partners",
      "project_subdomains": "Subdomains",
      "proposal_choice_lists": "Choice lists and subchoices",
      "proposal_templates": "Proposal templates",
      "sales": "Sales",
      "snippets": "Snippets",
      "surveys": "Surveys",
      "tasks": "Tasks",
      "template_projects": "Templates",
      "tickets": "Conversations",
      "todos": "Tasks (legacy)",
      "workflows_full": "Workflows: full",
      "workflows_phases": "Workflows: phases without elements",
      "workflows_tasks": "Workflows: phases + tasks"
    },
    "feature_matrix_notes": {
      "tasks": "Available on every MUP plan and SUP plans from Pro"
    }
  }
}
